import {
    useRef
} from "react";

const useDebounce = speed => {
    const timer = useRef(null);

    const debounce = callback => {
        if (timer.current) clearTimeout(timer.current);

        timer.current = setTimeout(() => callback(), speed);
    }
    
    return [debounce];
}

export default useDebounce;